export default __webpack_public_path__ + "static/media/take.83c3d7f4.svg";